import React from "react";
import {
    Dialog,
    DialogContent,
    Typography,
    Box,
    Button,
    Fade,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

export default function WelcomeModal({ open, onClose }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            TransitionComponent={Fade}
            PaperProps={{
                sx: {
                    borderRadius: "26px",
                    overflow: "hidden",
                    background:
                        "linear-gradient(145deg, #233344 0%, #1b2836 100%)",
                    color: "#fff",
                    boxShadow: "0 25px 80px rgba(0,0,0,0.45)",
                    border: "1px solid rgba(30,255,134,0.12)",
                },
            }}
        >
            {/* HEADER */}
            <Box
                sx={{
                    position: "relative",
                    padding: "32px 30px 22px",
                    background:
                        "linear-gradient(90deg, rgba(30,255,134,0.12) 0%, rgba(30,255,134,0.03) 100%)",
                    borderBottom: "1px solid rgba(255,255,255,0.05)",
                }}
            >
                {/* <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: 16,
                        right: 16,
                        color: "rgba(255,255,255,0.7)",
                        transition: "0.2s",
                        "&:hover": {
                            background: "rgba(255,255,255,0.08)",
                            color: "#1EFF86",
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton> */}

                {/* ÍCONE */}
                {/* <Box
                    sx={{
                        width: 78,
                        height: 78,
                        borderRadius: "24px",
                        background:
                            "linear-gradient(135deg, #1EFF86 0%, #11d86e 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2.5,
                        boxShadow: "0 12px 35px rgba(30,255,134,0.35)",
                    }}
                >
                    <RocketLaunchIcon
                        sx={{
                            fontSize: 40,
                            color: "#233344",
                        }}
                    />
                </Box> */}

                {/* TÍTULO */}
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 800,
                        lineHeight: 1.2,
                        mb: 1,
                        color: "#fff",
                    }}
                >
                    Bem-vindo(a) à Contblack 🚀
                </Typography>

                <Typography
                    sx={{
                        color: "rgba(255,255,255,0.72)",
                        fontSize: "15px",
                        lineHeight: 1.6,
                    }}
                >
                    Sua plataforma exclusiva já está pronta para uso.
                </Typography>
            </Box>

            {/* CONTEÚDO */}
            <DialogContent
                sx={{
                    padding: "30px",
                }}
            >
                <Typography
                    sx={{
                        color: "#d7e2ea",
                        fontSize: "15.5px",
                        lineHeight: 1.95,
                        mb: 4,
                    }}
                >
                    A partir de agora, você terá acesso a recursos,
                    acompanhamentos e funções desenvolvidas para facilitar sua
                    rotina.
                    <br />
                    <br />
                    Caso prefira, você já pode preencher as informações iniciais
                    da sua plataforma. Mas fique tranquilo(a): nosso time irá lhe
                    auxiliar integralmente durante a reunião agendada com o
                    consultor Contblack.
                    <br />
                    <br />
                    Se desejar um atendimento mais rápido, você também pode entrar
                    em contato conosco pelo WhatsApp através do chat flutuante
                    disponível ao lado.
                    <br />
                    <br />
                    <strong style={{ color: "#1EFF86" }}>
                        Agora, vamos lhe apresentar o passo a passo da plataforma e
                        todas as funções exclusivas disponíveis para você!
                    </strong>
                </Typography>

                {/* BOTÕES */}
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        flexWrap: "wrap",
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={onClose}
                        sx={{
                            flex: 1,
                            minHeight: 54,
                            borderRadius: "16px",
                            fontWeight: 700,
                            textTransform: "none",
                            fontSize: "15px",
                            background:
                                "linear-gradient(135deg, #1EFF86 0%, #15d970 100%)",
                            color: "#233344",
                            boxShadow: "0 10px 30px rgba(30,255,134,0.28)",
                            "&:hover": {
                                background:
                                    "linear-gradient(135deg, #27ff90 0%, #18e578 100%)",
                                boxShadow: "0 14px 35px rgba(30,255,134,0.38)",
                            },
                        }}
                    >
                        Começar Tour da Plataforma
                    </Button>

                    {/* <Button
                        variant="outlined"
                        onClick={onClose}
                        sx={{
                            flex: 1,
                            minHeight: 54,
                            borderRadius: "16px",
                            fontWeight: 700,
                            textTransform: "none",
                            fontSize: "15px",
                            color: "#1EFF86",
                            borderColor: "rgba(30,255,134,0.35)",
                            background: "rgba(30,255,134,0.03)",
                            "&:hover": {
                                borderColor: "#1EFF86",
                                background: "rgba(30,255,134,0.08)",
                            },
                        }}
                    >
                        Explorar Plataforma
                    </Button> */}
                </Box>
            </DialogContent>
        </Dialog>
    );
}